import { createLevelContext } from "../_lib/createLevelContext";

const { Provider, useValue } = createLevelContext("fourth");

export const FourthLevelProvider = Provider;
export const useFourthLevelContext = useValue;
